import type { FC } from "react"
import { useTranslation } from "react-i18next"
import Button from "@mui/material/Button"

interface IDevicesTableToolbarSelectProps {
  handleOpen: () => void
}

const DevicesTableToolbarSelect: FC<IDevicesTableToolbarSelectProps> = ({
  handleOpen,
}) => {
  const { t } = useTranslation()

  return (
    <Button size="small" color="error" onClick={handleOpen} sx={{ fontSize: "0.75rem" }}>
      {t("device_groups.REMOVE_DEVICES")}
    </Button>
  )
}

export default DevicesTableToolbarSelect
